import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || 'https://rj2psn7fng.execute-api.us-east-1.amazonaws.com/v1';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) throw data;
      setSent(true);
    } catch (err) {
      setError(err.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Forgot Password</h2>
        {sent ? (
          <div>
            <p className="auth-subtitle">If this email is registered, you'll receive a reset link shortly. Check your inbox.</p>
            <Link to="/vendor/login" className="auth-link" style={{display:'block', marginTop:'1.5rem'}}>← Back to login</Link>
          </div>
        ) : (
          <>
            <p className="auth-subtitle">Enter your email and we'll send you a link to reset your password.</p>
            {error && <div className="auth-error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <input type="email" placeholder="Your email address" value={email} onChange={e => setEmail(e.target.value)} required />
              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
            <p className="auth-link"><Link to="/vendor/login">Vendor login</Link> • <Link to="/customer/login">Customer login</Link></p>
          </>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
